// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3EOjN","log":"ModalInventoryLogs_log__103ib","date":"ModalInventoryLogs_date__23nZE","userName":"ModalInventoryLogs_userName__1XeOE"};